import {NgModule} from '@angular/core';
import {BorrowerMenuComponent} from './borrower-menu.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [BorrowerMenuComponent],
    imports: [CommonModule, RouterModule],
    exports: [BorrowerMenuComponent]
})
export class BorrowerMenuModule {
}